import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export default function AnalyticsFilters({
  dateFrom, setDateFrom, dateTo, setDateTo,
  locationFilter, setLocationFilter, statusFilter, setStatusFilter,
  locations, onApply, onClear,
}) {
  return (
    <Card className="p-4 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4">
        <div>
          <Label className="text-xs uppercase font-bold text-muted-foreground mb-1 block">
            From Date
          </Label>
          <Input
            type="date"
            value={dateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
            className="h-10"
            data-testid="date-from-filter"
          />
        </div>

        <div>
          <Label className="text-xs uppercase font-bold text-muted-foreground mb-1 block">
            To Date
          </Label>
          <Input
            type="date"
            value={dateTo}
            onChange={(e) => setDateTo(e.target.value)}
            className="h-10"
            data-testid="date-to-filter"
          />
        </div>

        <div>
          <Label className="text-xs uppercase font-bold text-muted-foreground mb-1 block">
            Location
          </Label>
          <Select value={locationFilter} onValueChange={setLocationFilter}>
            <SelectTrigger className="h-10" data-testid="location-filter">
              <SelectValue placeholder="All Locations" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Locations</SelectItem>
              {locations.map(loc => (
                <SelectItem key={loc.id} value={loc.id}>{loc.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div>
          <Label className="text-xs uppercase font-bold text-muted-foreground mb-1 block">
            Status
          </Label>
          <Select value={statusFilter} onValueChange={setStatusFilter}>
            <SelectTrigger className="h-10" data-testid="status-filter">
              <SelectValue placeholder="All Statuses" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Statuses</SelectItem>
              <SelectItem value="PENDING_ALLOCATION">Pending Allocation</SelectItem>
              <SelectItem value="AWAITING_PAYMENT">Awaiting Payment</SelectItem>
              <SelectItem value="CONFIRMED">Confirmed</SelectItem>
              <SelectItem value="CANCELLED">Cancelled</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="flex gap-3">
        <Button onClick={onApply} className="btn-volt" data-testid="apply-filters">
          Apply Filters
        </Button>
        <Button onClick={onClear} variant="outline" data-testid="clear-filters">
          Clear Filters
        </Button>
      </div>
    </Card>
  );
}
